export default [
  { label: 'Combined', value: '*', lock: false },
  { label: 'UMR', value: 'Unique_Market_Reference_UMR', lock: true },
  { label: 'Risk Code', value: 'Risk_Code', lock: false },
  { label: 'Cat Code', value: 'Lloyds_Cat_Code', lock: false },
  { label: 'Section No', value: 'Section_No', lock: false },
  {label: 'Settlement Currency', value: 'Settlement_Currency', lock: false},
  {label: 'Year of Account', value: 'Year_of_Account', lock: false}
];
